import React, { useEffect, useState } from 'react';
import { useForm, SubmitHandler, Controller } from 'react-hook-form';
import Input from '../../../components/elements/form/input';
import Teaxtarea from '../../../components/elements/form/textarea';
import SelectBox from '../../../components/elements/form/selectBox';
import Button from '../../../components/elements/button';
import Icon from '../../../components/icons';
import { useAppLoader } from '../../../_common/pageLoader/appLoaderHook';
import { useSpearPartsApi } from '../../../store/api/hooks/spearPartsApiHook';
import toast from 'react-hot-toast';
import { MASTER_DROPDOWN_PAGE_SIZE } from '../../../_common/constant';
import { useAssetsApi } from '../../../store/api/hooks/assetsApiHook';
import { useVendorsApi } from '../../../store/api/hooks/vendorsApiHook';
import { getSelectedOption, localDate } from '../../../_common/functions';
import FileUpload from '../../../components/elements/form/fileUplaod';
import { Link, useParams } from 'react-router-dom';
import { useDialog } from '../../../store/api/hooks/dialogHook';
import { useFacilitiesApi } from '../../../store/api/hooks/facilitiesApiHook';
import Datepicker from '../../../components/elements/form/datepicker';

interface FormProps {
    _ref?: any;
    fromList?: any
    editData?: any;
    onCreate?: () => void
    onCancel?: () => void
    show?: boolean;
}
type FormValues = {
    returnPartsID: any;
    partsID: any;
    warrantyStartDate: any;
    warrantyEndDate: any;
    vendorDocNo: any;
    warrantyTermsID: any;
    warrantyAMCCost: any;
    partsCategoryID: any;
    vendorID: any;

    warrantyImage: any;
};


const CreateWarrenty: React.FC<FormProps> = ({ _ref, editData, fromList, onCreate = () => { }, onCancel = () => { }, show }) => {
    const { control, register, handleSubmit, setValue, watch, getValues, formState: { errors }, reset } = useForm<FormValues>();
    const spearPartsAPI = useSpearPartsApi();
    const facilityApi: any = useFacilitiesApi();
    const assetAPI: any = useAssetsApi();
    const vendorsApi: any = useVendorsApi();
    const { showLoader, hideLoader } = useAppLoader();
    const { confirm } = useDialog();
    const params: any = useParams();
    const [vendorList, setVendorList] = React.useState<any[]>([]);
    const [unitList, setUnitList] = React.useState<any[]>([]);
    const [warrantyTermList, setWarrantyTermsList] = React.useState<any[]>([]);

    const [working, setWorking] = useState<boolean>(false);
    const [changeDate, setChangeDate] = useState<boolean>(false);
    const [partsImg, setPartsImg] = useState<any>(null);
    const [partsAttachment, setPartsAttachment] = useState<any>(null);
    const [attachmentList, setAttachmentList] = React.useState<any[]>([]);

    ///////////
    // --- Warranty AMCCost formatting logic ---
    const warrantyAMCCostValue = watch("warrantyAMCCost");
    const [displayWarrantyCost, setDisplayWarrantyCost] = React.useState("");

    console.log('SHOW~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~', show);


    let imgExt = ['.png', '.jpg', '.jpeg', '.webp'];


    const formReset = () => {

        reset({

            warrantyStartDate: '',
            warrantyEndDate: '',
            vendorDocNo: '',
            warrantyTermsID: '',
            warrantyAMCCost: '',
            vendorID: '',

            warrantyImage: ''

        });
        setAttachmentList([]);
    }


    const onSubmit: SubmitHandler<FormValues> = data => {
        console.log("Submited data=================", data)
        setWorking(true);
        let payload: any = {


            "vendorDocNo": data.vendorDocNo,
            "vendorID": data.vendorID?.value,
            "warrantyStartDate": data.warrantyStartDate,
            "warrantyEndDate": data.warrantyEndDate,
            "warrantyTermsID": data.warrantyTermsID?.value,
            "warrantyAMCCost": data.warrantyAMCCost
        }
        if (fromList) {

            payload['assetID'] = editData.assetID;
        } else {
            payload['assetID'] = params.id;

        }

        if (editData && !fromList) {
            payload['warrantyID'] = editData.warrantyID;
        }

        showLoader();
        assetAPI.SaveAssetWarranty(payload, (resp: any) => {
            if (partsImg) {
                const formData = new FormData();
                formData.append('warrantyID', editData ? editData.warrantyID : resp.returnID);
                formData.append('InputFile', partsImg);
                savePartsImage(formData); // savePartsAttachments
            } else {
                onCreate();
                onCancel();
                console.log(resp, "Submited resp")
                toast.success(resp?.message)
                formReset();
                hideLoader();
                setWorking(false);
            }


        }, (error: any) => {
            console.log('error =>', error);
            hideLoader();
            toast.error(error);
            setWorking(false);
        });
    };



    // useEffect(() => {
    // 	if (_ref?.current) {
    // 		_ref.current.reset = formReset;
    // 	}
    // }, [_ref])

    useEffect(() => {
        if (editData && !fromList) {

            reset({

                warrantyStartDate: localDate(editData.warrantyStartDate),
                warrantyEndDate: localDate(editData.warrantyEndDate),
                vendorDocNo: editData.vendorDocNo,
                warrantyTermsID: getSelectedOption(editData.warrantyTermsID, warrantyTermList),
                warrantyAMCCost: editData.warrantyAMCCost,



                vendorID: getSelectedOption(editData.vendorID, vendorList),

                // warrantyImage: editData.imageFullPath
            });
            const payload: any = {
                warrantyID: editData?.warrantyID
            }


            assetAPI.GetAssetWarrantyAttachments(payload, (resp: any) => {
                hideLoader();
                console.log("resp===========?", resp)
                const attachmentList = resp?.assetWarrantyAttachmentList ? resp?.assetWarrantyAttachmentList : [];
                setAttachmentList(attachmentList);
                setValue('warrantyEndDate', localDate(editData.warrantyEndDate));

            }, (error: any) => {
                hideLoader();
                setValue('warrantyEndDate', localDate(editData.warrantyEndDate));
            })



        } else {
            formReset();
            setAttachmentList([]);
            if (_ref?.current) {
                _ref.current.reset = formReset;
            }
        }
    }, [_ref, editData, vendorList, warrantyTermList,]);



    const savePartsImage = (data: any) => {
        showLoader();
        assetAPI.SaveAssetWarrantyAttachment(data, (resp: any) => {
            onCreate();
            onCancel();
            console.log(resp, "Submited resp")
            toast.success(resp?.message)
            formReset();
            hideLoader();
            setWorking(false);
        }, (error: any) => {
            hideLoader();
            toast.error(error);
            setWorking(false);
        });
    }



    const changeImgHandler = (e: any) => {
        setPartsImg(e.target.files[0]);
        if (editData) {
            const formData = new FormData();
            formData.append('warrantyID', editData.warrantyID);
            formData.append('InputFile', e.target.files[0]);
            //savePartsImage(formData); // savePartsAttachments
        }
    }




    const getvenderList = () => {
        showLoader();
        vendorsApi.FilteredServiceProviderList({
            vendorServiceTypeIDs: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16]
        }, (resp: any) => {
            const vendorList = (resp?.vendorList?.map((item: any) => {
                return {
                    label: item.name,
                    value: item.vendorID
                }
            }));
            setVendorList(vendorList);
            hideLoader();
        }, (error: any) => {
            setVendorList([]);
            hideLoader();
        });
    }
    const GetWarrantyTermList = () => {
        showLoader();
        assetAPI.GetWarrantyTermList({ pageSize: MASTER_DROPDOWN_PAGE_SIZE, pageNumber: 1 }, (resp: any) => {
            const vendorList = (resp?.warrantyTermList?.map((item: any) => {
                return {
                    label: item.warrantyTermName,
                    value: item.warrantyTermsID
                }
            }));
            setWarrantyTermsList(vendorList);

            hideLoader();
        }, (error: any) => {
            setWarrantyTermsList([]);
            hideLoader();
        });
    }


    useEffect(() => {

        getvenderList();
        GetWarrantyTermList();


    }, []);
    const WatchWarrantyStartDate = watch('warrantyStartDate');


    useEffect(() => {
        console.log("changeDate", changeDate);
        if (WatchWarrantyStartDate && changeDate == true) {
            setValue('warrantyEndDate', '');
            console.log("warrantyEndDate", 'fsfsd');

        }

    }, [WatchWarrantyStartDate, changeDate])
    return (
        <form onSubmit={handleSubmit(onSubmit)} ref={_ref} className='flex flex-col h-full'>
            <div className='flex-1 overflow-auto'>
                <h4 className='font-semibold text-[0.938rem] pb-4 uppercase'>Basic Information</h4>



                <div className='grid grid-cols-2 gap-2'>
                    <Controller
                        name="warrantyStartDate"
                        control={control}
                        rules={{ required: 'Warranty Start Date is required' }}
                        render={({ field: { value, onChange } }) => (
                            <Datepicker
                                label="Warranty Start Date"
                                required
                                value={value}
                                onChange={(e: any) => {
                                    onChange(e)
                                    setChangeDate(true)

                                }}
                                error={errors.warrantyStartDate?.message as any}
                            />
                        )}
                    />
                    <Controller
                        name="warrantyEndDate"
                        control={control}
                        rules={{ required: 'Warranty End Date is required' }}
                        render={({ field: { value, onChange } }) => (
                            <Datepicker
                                label="Warranty End Date"
                                required
                                value={value}
                                minDate={WatchWarrantyStartDate}
                                onChange={onChange}

                                error={errors.warrantyEndDate?.message as any}
                            />
                        )}
                    />
                </div>


                <div className='grid grid-cols-2 gap-2'>
                    <Controller
                        name="vendorDocNo"
                        control={control}
                        rules={{ required: 'Document No is required' }}
                        render={({ field: { value, onChange } }) => (

                            <Input
                                label="Document No"
                                type="text"
                                required
                                value={value}
                                onChange={onChange}
                                placeholder="Enter document number"
                                error={errors.vendorDocNo?.message as any}
                            />

                        )}
                    />
                    <Controller
                        name='warrantyTermsID'
                        control={control}
                        render={({ field: { value, onChange } }) => (
                            <SelectBox
                                label='Warranty Terms'
                                value={value}
                                onChange={onChange}

                                placeholder='Choose Warranty Terms'
                                options={warrantyTermList ? warrantyTermList : []}
                                className='mb-0'
                                error={errors.warrantyTermsID?.message as any}
                            />
                        )}
                    />
                </div>


                <div className='grid grid-cols-2 gap-2'>

                    <Controller
                        name='vendorID'
                        control={control}
                        rules={{ required: 'Vendor is required' }}
                        render={({ field: { value, onChange } }) => (
                            <SelectBox
                                label='Vendor'
                                value={value}
                                onChange={onChange}

                                required
                                placeholder='Choose Vendor'
                                options={vendorList ? vendorList : []}
                                className='mb-0'
                                error={errors.vendorID?.message as any}
                            />
                        )}
                    />
                    {/* <Controller
                        name="warrantyAMCCost"
                        control={control}
                        rules={{ required: 'Warranty Cost is required' }}
                        render={({ field: { value, onChange } }) => (

                            <Input
                                label="Warranty Cost"
                                type="text"
                                required
                                value={value}
                                onChange={onChange}
                                placeholder="Enter Cost"
                                error={errors.warrantyAMCCost?.message as any}
                            />

                        )}
                    /> */}
                    <div className={`my-6`}>
                        <p className={`font-normal text-[0.938rem] leading-none`}>Warranty Cost</p>
                        <div className={`flex`}>
                            <div className={`pt-2`}><span className={`font-semibold w-9 border border-gray-200 h-[46px] flex items-center justify-center rounded-tl-md rounded-bl-md border-r-0`}>$</span></div>
                            <Controller
                                name="warrantyAMCCost"
                                control={control}
                                // rules={{ required: 'Cost Per Unit Required' }}
                                render={({ field: { value, onChange } }) => (
                                    <Input
                                        label={``}
                                        type="number" // keep as text to allow decimal typing
                                        value={value}
                                        onChange={onChange}
                                        placeholder="0.00"
                                        error={errors.warrantyAMCCost?.message as any}
                                        className={`text-right !rounded-md !border-gray-300 w-full !my-0 input-no-spinner`}
                                    />
                                )}
                            />
                        </div>
                    </div>
                </div>
                <Controller
                    name='warrantyImage'
                    control={control}
                    render={({ field: { value, onChange } }) => (
                        <FileUpload
                            label='Upload Image/ Pdf'
                            value={value}

                            accept=".jpg, .jpeg, .png, .pdf"
                            onChange={(e: any) => {
                                changeImgHandler(e);
                                onChange(e.target.files[0])
                            }}
                            placeholder='Choose Processing Facility'

                        />
                    )}
                />

                {
                    attachmentList && attachmentList.length > 0 && <div  >
                        <h4 className='font-semibold text-[0.938rem]  uppercase'>Files</h4>
                        <div className='grid grid-cols-5 gap-3'>
                            {
                                attachmentList.map((item: any, index: number) => {
                                    const found = imgExt.some((word) => item.imageOriginalFileName.includes(word));
                                    return (
                                        <div key={`attachmentList${index}`} className='border border-primary rounded-md flex px-2 py-2 text-[0.813rem] text-primary text-center justify-center items-center relative'>
                                            <Link to={item.fullFilePath} target='_blank' >
                                                {found ?
                                                    <img src={item.fullFilePath} alt={item.imageOriginalFileName} className="max-w-full max-h-20" />
                                                    : <p className='truncate max-w-[100px] overflow-hidden' title={item.imageOriginalFileName}>{item.imageOriginalFileName}</p>
                                                }
                                            </Link>
                                            {/* <span className='text-sm text-gray-400 inline-block ms-1'>({item.fileSize})</span> */}

                                        </div>
                                    )
                                })
                            }

                        </div>
                    </div>
                }


            </div>
            <div className='flex justify-end gap-2 flex-shrink-0 border-t border-gray-200 pt-2'>
                <Button type="button" theme='secondary' working={working} onClick={() => {
                    formReset();
                    onCancel();
                }}>Cancel</Button>
                <Button type="submit" working={working}>Save</Button>
            </div>

            {/* <input id="assetName" {...register('assetName', { required: true })} />
            {errors.assetName && <span>This field is required</span>}

            <div>
                <label htmlFor="assetType">Asset Type</label>
                <input id="assetType" {...register('assetType', { required: true })} />
                {errors.assetType && <span>This field is required</span>}
            </div>

            <div>
                <label htmlFor="purchaseDate">Purchase Date</label>
                <input id="purchaseDate" type="date" {...register('purchaseDate', { required: true })} />
                {errors.purchaseDate && <span>This field is required</span>}
            </div> */}

            {/* <button type="submit">Create Asset</button> */}
        </form>
    );
};

export default CreateWarrenty;